import { client } from "./apolloClient";
import { clearAuthData } from "./authStorage";
import { hasCallingInstance, runShutdownHook } from "./telephony/callingSession";

// Long enough for the phone to end a running call and report it, short enough not to hold up the sign-out.
export const LOGOUT_PHONE_TIMEOUT_MS = 2_000;

let signingOut: Promise<void> | null = null;

const signOut = async (): Promise<void> => {
  // The end of a running call is reported with the agent's token, so the phone shuts down before it goes.
  await runShutdownHook(LOGOUT_PHONE_TIMEOUT_MS);
  client.stop();
  await client.clearStore();
  clearAuthData();
  // The phone's SDK keeps the agent's Webex token in this page's memory; a reload drops it before another agent signs in.
  if (hasCallingInstance()) window.location.reload();
};

// A token error answers the shutdown's own request too and calls logout again: that call joins this one
// instead of waiting for the shutdown it would start.
export const logout = (): Promise<void> => {
  if (signingOut) return signingOut;
  // Starting in a microtask registers this logout before the shutdown can ask for another one.
  const current = Promise.resolve()
    .then(signOut)
    .finally(() => {
      signingOut = null;
    });
  signingOut = current;
  return current;
};
